import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const FooterSectionLink = ({ hash, children, testid }) => (
  <Link
    to={`/#${hash}`}
    data-testid={testid}
    className="text-[#d4d4d8] hover:text-[#60A5FA] transition-colors"
  >
    {children}
  </Link>
);

const linkCls = "text-[#d4d4d8] hover:text-[#60A5FA] transition-colors";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#111827]">
    <div className="bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-5">
        <Link to="/" data-testid="footer-brand-link" className="inline-block">
          <Logo markSize={48} textSize="text-[24px]" />
        </Link>
      </div>
    </div>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-10">
        <p className="text-base text-[#d4d4d8] leading-relaxed max-w-sm">
          The operating system for everyday civil disputes. End to end,
          across all 50 states.
        </p>
        <div className="grid grid-cols-2 gap-10 sm:flex sm:gap-16">
          <div>
            <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#71717a] mb-4">
              Site
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <FooterSectionLink hash="why" testid="footer-why-link">
                  Why We Exist
                </FooterSectionLink>
              </li>
              <li>
                <FooterSectionLink hash="problem" testid="footer-problem-link">
                  The Problem
                </FooterSectionLink>
              </li>
              <li>
                <Link to="/pricing" data-testid="footer-pricing-link" className={linkCls}>
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/track" data-testid="footer-track-link" className={linkCls}>
                  Track Your Case
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold tracking-[0.25em] uppercase text-[#71717a] mb-4">
              Packages
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/pricing#plan-letter" data-testid="footer-package-letter-link" className={linkCls}>
                  Standard Package — $39
                </Link>
              </li>
              <li>
                <Link to="/pricing#plan-full" data-testid="footer-package-full-link" className={linkCls}>
                  Premium Package — $79
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-[#27272A] mt-12 pt-8 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-xs text-[#71717a]">
          © {new Date().getFullYear()} No Lawyer Lawsuit. All rights reserved.
        </p>
        <p className="text-xs text-[#52525B] max-w-md">
          No Lawyer Lawsuit is not a law firm and does not provide legal advice. We
          prepare and send documents at your direction.
        </p>
      </div>
    </div>
  </footer>
);
